module.exports = __webpack_public_path__ + "static/venice20897-860f73056ca38e0aa445a043b7bec1e8.webp";